<template>
  <div class="etc-plate-no-board-wrap" v-show="focusIndex!==null" @click="hideBoard">
    <section class="etc-plate-no-board" @click.stop>
      <template v-if="focusIndex===0">
        <div class="key-line" v-for="(keys, i) in proKeys" :key="i+'p'">
          <button class="key" :class="{'v-hidden':!k}" v-for="(k, ii) in keys" :key="i+ii+'p'" @click="tapKey(k)">{{k}}</button>
        </div>
      </template>
      <template v-if="focusIndex!==0">
        <div class="key-line">
          <button class="key" :disabled="focusIndex===1" v-for="(k, ii) in numKeys" :key="ii+'n'" @click="tapKey(k)">{{k}}</button>
        </div>
      </template>
      <template v-if="focusIndex!==0">
        <div class="key-line" v-for="(keys, i) in letKeys" :key="i+'l'">
          <button class="key" :class="{'v-hidden':!k}" v-for="(k, ii) in keys" :key="i+ii+'l'" @click="tapKey(k)">{{k}}</button>
        </div>
      </template>
      <div class="else-keys">
        <span class="key delete-key" @click="deleteKey"><i class="iconfont etc-icon-delete"></i></span>
        <span class="key confirm-key" @click="confirmKey">确定</span>
      </div>
    </section>
  </div>
</template>

<script>
// mixins
import FunMixin from '@/mixins/funMixin'

const PROVINCE = [
  ['京', '津', '沪', '渝', '苏', '浙', '豫', '粤', '川', '陕'],
  ['冀', '辽', '吉', '皖', '闽', '鄂', '湘', '鲁', '晋', '黑'],
  ['赣', '贵', '甘', '桂', '琼', '云', '青', '蒙', '藏', '宁'],
  ['新', '', '', '', '', '', '', '', '', '']
]
const NUMBERS = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
const LETTER1 = [
  ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'J', 'K'],
  ['L', 'M', 'N', 'P', 'Q', 'R', 'S', 'T', 'U', 'V'],
  ['W', 'X', 'Y', 'Z', '', '', '', '', '', '']]
const LETTER2 = [
  ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'J', 'K'],
  ['L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U'],
  ['V', 'W', 'X', 'Y', 'Z', '', '', '', '', '']]

export default {
  name: 'plateNoBoard',
  mixins: [FunMixin],
  components: {},
  model: {
    prop: 'focusIndex',
    event: 'change'
  },
  props: {
    focusIndex: Number
  },
  data() {
    return {
      proKeys: PROVINCE,
      numKeys: NUMBERS,
      letKeys: LETTER1
    }
  },
  computed: {
  },
  methods: {
    hideBoard() {
      // this.focusIndex = null
      this.$emit('change', null)
    },
    deleteKey() {
      this.$emit('keyBoardChange', {type: 'deleteKey'})
    },
    confirmKey() {
      this.$emit('keyBoardChange', {type: 'confirmKey'})
    },
    tapKey(k) {
      this.focusIndex === 0 && (this.letKeys = k === '青' ? LETTER2 : LETTER1)
      this.$emit('keyBoardChange', {type: 'tapKey', val: k})
    }
  },
  created() {
  }
}
</script>

<style scoped lang="scss">
@import "../style/cool.practical";
.etc-plate-no-board-wrap{
  @extend %all-page;
  z-index: 100;
}
.etc-plate-no-board{
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0;
  background-color: #dadada;
  z-index: 99;
  padding: 24px 14px;
  .key-line{
    margin-top: 20px;
    @extend %flex-space-between;
    &:first-child{
      margin-top: 0;
    }
  }
  .key{
    width: 64px;
    height: 84px;
    line-height: 84px;
    background-color: #fff;
    font-size: 40px;
    color: #333;
    text-align: center;
    box-shadow: 0 1px 0 0 #999999;
    border-radius: 8px;
    margin: 0 5px;
    &[disabled]{
      color: #999999;
      background-color: #eee;
    }
    &:active{
      background-color: #d2d2d2;
    }
  }
  .else-keys{
    position: absolute;
    right: 14px;
    bottom: 24px;
    @extend %flex-start;
    .delete-key{
      width: 90px;
      i{
        font-size: 46px;
      }
    }
    .confirm-key{
      width: 138px;
    }
  }
}
</style>
